export default __webpack_public_path__ + "static/media/banner_tringleimg.bf529549.svg";